import * as React from 'react';
import { Link } from 'react-router-dom';

interface INavLink {
	key: string;
	link: string;
	text: string;
	subtext?: string;
	hidden?: boolean;
	children?: any;
}

interface INavPanelProps {
	selected?: string;
	links: INavLink[];
	disabled?: string[];
}

interface INavPanelState {
	isMenuOpen: boolean;
}

export class NavPanel extends React.Component<INavPanelProps, INavPanelState>  {
	constructor(props: INavPanelProps) {
		super(props);
		this.state = { isMenuOpen: false };
	}

	public toggleMenu() {
		this.setState({ isMenuOpen: !this.state.isMenuOpen });
	}

	public render() {
		const { links, selected, disabled = [] } = this.props;
		const classes = (key: string): string => [
			'nav-panel__link',
			selected === key ? 'nav-panel__link--selected' : '',
			disabled.includes(key) ? 'nav-panel__link--disabled' : ''
		].join(' ').trim();

		const closeOnMobile = (isDisabled: boolean) => (e: React.MouseEvent<HTMLElement>) => {
			this.toggleMenu();
			if (isDisabled) {
				e.preventDefault();
				return false;
			}
			return true;
		};

		return <div className="nav-panel">
			<div
				className={`nav-panel__mobile-trigger${this.state.isMenuOpen ? ' nav-panel__mobile-trigger--open' : ''}`}
				onClick={this.toggleMenu.bind(this)}>Show menu +</div>
			<ul className={`nav-panel__list${this.state.isMenuOpen ? ' nav-panel__list--open' : ''}`}>
				{links.map((option, o) => {
					return option.hidden ? null : <li className="nav-panel__item" key={o}>
						<Link
							className={classes(option.key)}
							to={option.link}
							onClick={closeOnMobile(disabled.includes(option.key))}>
							<span className="nav-panel__text">{option.text || ''}</span>
							<span className="nav-panel__subtext">{option.subtext || ''}</span>
							<div className="nav-panel__children">
								{option.children}
							</div>
						</Link>
					</li>;
				})}
			</ul>
		</div>;
	}
}
